'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import Small from 'UIComponents/elements/Small';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink';
import UILock from 'ui-addon-upgrades/icons/UILock';
import { KBArticles } from 'AdsUI/lib/Constants';
import withScreen from 'AdsUI/lib/withScreen';
import { isFreeTier, isStarterTier } from 'AdsUI/selectors/AuthSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
const VIEW_WIDTH = 325;

const AttributionView = ({
  selectedView,
  view,
  onChangeFilters,
  locked = false
}) => /*#__PURE__*/_jsxs(UILink, {
  onClick: () => onChangeFilters({
    attributionView: view
  }),
  style: {
    width: VIEW_WIDTH,
    backgroundColor: view === selectedView && CALYPSO_LIGHT
  },
  children: [/*#__PURE__*/_jsxs("div", {
    className: "is--heading-7 m-bottom-1",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `filters.attributionViews.${view}.text`
    }), locked && /*#__PURE__*/_jsx("div", {
      className: "m-left-1 display-inline-block",
      children: /*#__PURE__*/_jsx(UILock, {})
    })]
  }), /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `filters.attributionViews.${view}.message`
    })
  })]
});

const FakePQLSelect = ({
  children,
  disabled,
  onOpen,
  onSelectedOptionChange = () => false,
  selectedView
}) => /*#__PURE__*/_jsx(UIDropdown, {
  "data-test-id": "attribution-select",
  buttonUse: "link",
  className: "p-right-2",
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `filters.attributionViews.${selectedView}.text`
  }),
  disabled: disabled,
  placement: "bottom right",
  onOpenChange: onOpen,
  children: children(onSelectedOptionChange)
});

const LockedAttributionViews = ({
  lockedAttributionViews,
  selectedView,
  onSelectedOptionChange
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [lockedAttributionViews.map(view => /*#__PURE__*/_jsx(AttributionView, {
    view: view,
    selectedView: selectedView,
    locked: true,
    onChangeFilters: () => {
      onSelectedOptionChange({
        target: {
          value: {
            locked: true
          }
        }
      });
    }
  }, view)), /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsxs(Small, {
    style: {
      width: VIEW_WIDTH,
      display: 'block'
    },
    className: "p-x-5",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.attributionViews.footer"
    }), ' ', /*#__PURE__*/_jsx(KnowledgeBaseLink, {
      kbArticle: KBArticles.ADS_ATTRIBUTION,
      context: "attribution-filter-dropdown",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "filters.attributionViews.footerLink"
      })
    })]
  })]
});

const AttributionViewSelect = ({
  selectedView,
  attributionViews,
  lockedAttributionViews = [],
  onChangeFilters,
  disabled = false
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('ads-attribution-views');
  return /*#__PURE__*/_jsx(FakePQLSelect, {
    selectedView: selectedView,
    disabled: disabled,
    onSelectedOptionChange: e => {
      if (e.target.value.locked) {
        openUpgradeModal();
      }
    },
    children: onSelectedOptionChange => /*#__PURE__*/_jsxs(UIList, {
      children: [attributionViews.map(view => /*#__PURE__*/_jsx(AttributionView, {
        view: view,
        selectedView: selectedView,
        onChangeFilters: (...args) => {
          onSelectedOptionChange({
            target: {
              value: {
                locked: false
              }
            }
          });
          onChangeFilters(...args);
        }
      }, view)), /*#__PURE__*/_jsx(LockedAttributionViews, {
        lockedAttributionViews: lockedAttributionViews,
        selectedView: selectedView,
        onSelectedOptionChange: onSelectedOptionChange
      })]
    })
  });
};

export default withScreen(connect(state => ({
  freeOrStarterTier: isFreeTier(state) || isStarterTier(state)
}))(AttributionViewSelect));